import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PersonAddress } from '../_models';
import { environment } from '../../../environments/environment';

@Injectable()
export class PersonAddressService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getPersonAddresses(): Observable<PersonAddress[]> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/personAddresses')
      .pipe(map((response) => response));
  }

  getPersonAddress(id: number): Observable<PersonAddress> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/personAddresses/' + id)
      .pipe(map((response) => response));
  }

  savePersonAddress(personAddressItem): Observable<PersonAddress> {
    const personAddress = { ...personAddressItem };
    delete personAddress.lastUpdated;
    delete personAddress.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    personAddress.companyId = companySelected ? companySelected.id : null;

    if (personAddress.user != null && personAddress.user.id != null) {
      personAddress.user = { id: personAddress.user.id };
    }
    if (personAddress.id) {
      return this.http
        .put<PersonAddress>(
          this.apiBaseUrl + 'api/private/v1/personAddresses/' + personAddress.id,
          personAddress
        )
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<PersonAddress>(this.apiBaseUrl + 'api/private/v1/personAddresses/', personAddress)
        .pipe(map((response) => response));
    }
  }

  deletePersonAddress(id: number): Observable<PersonAddress> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/personAddresses/' + id).pipe(
      map(() => {
        return { id } as PersonAddress;
      })
    );
  }
}
